import type { Entry } from 'contentful';
import type { ComponentProps } from 'react';

import { Banner } from './banner';
import { Container } from './container';
import { Faq } from './faq';
import { FeatureBanner } from './feature-banner';

// Register components here as their Contentful props are migrated to UI models.
// Until then, composition entries use the legacy renderer.
export const config = { banner: Banner, container: Container, featureBanner: FeatureBanner, faq: Faq } as const;

export type Config = typeof config;
export type Model = {
    contentType: keyof Config;
    props: ComponentProps<Config[keyof Config]>;
};
export type CompositionItem = Entry | Model;
